import { render, staticRenderFns } from "./PrivacyNotiCatch.vue?vue&type=template&id=ef253736&scoped=true"
import script from "./PrivacyNotiCatch.vue?vue&type=script&lang=js"
export * from "./PrivacyNotiCatch.vue?vue&type=script&lang=js"
import style0 from "./PrivacyNotiCatch.vue?vue&type=style&index=0&id=ef253736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef253736",
  null
  
)

export default component.exports